import React, { useState, useEffect } from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import PortfolioTopNav from '../components/PortfolioTopNav';
import Footer from '../components/Footer';
import LandingHeroStage from '../components/LandingHeroStage';
import LandingClosingInvitation from '../components/LandingClosingInvitation';
/* IMPORTS */

function useScrollPosition() {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scroll;
}

function LandingPage() {
  const scroll = useScrollPosition();

  return (
    <div className="la-root" style={{ "--scroll": scroll }}>
      <div className="la-layout-1">
        <div id="landingtopnav" className="la-slot-landingtopnav">
          <PortfolioTopNav activePage={"Landing"} />
        </div>
        <div id="landingherostage" className="la-slot-landingherostage">
          <LandingHeroStage />
        </div>
        <div id="landingclosinginvitation" className="la-slot-landingclosinginvitation">
          <LandingClosingInvitation />
        </div>
        <div id="footer" className="la-slot-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;